<div
  class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center bg-gray-50 cursor-pointer transition-all hover:border-gray-400 hover:bg-gray-100"
  [class.border-blue-500]="isDragging"
  [class.bg-blue-50]="isDragging"
  (click)="fileInput.click()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <ng-content></ng-content>
</div>

<input
  #fileInput
  type="file"
  [accept]="accept"
  (change)="onFileSelect($event)"
  class="hidden"
/>